import React, { memo } from "react";
// @ts-ignore
import bgTop from "./../Assets/Images/bg-top-profile.svg";
// @ts-ignore
import bgBottom from "./../Assets/Images/bg-bottom.png";

const EditProfileSkeleton = () => {
  return (
    <div className="position-relative placeholder-glow" role="status" aria-label="Loading">
      <img className="bg-top d-none d-lg-block" src={bgTop} alt="img" />
      <div className="container-xxl my-4">
        <div className="card shadow br-17px p-5 my-5">
          <div className="card-body">
            <div className="row">
              <div className="col-md-2 col-lg-1 text-center text-md-start">
                <span
                  className="placeholder d-block wh-99px rounded-circle mx-auto mx-md-0"
                  aria-hidden="true"
                />
              </div>
              <div className="col-md-7 col-xl-8 ps-lg-5 ps-xl-4 py-md-3 text-center text-md-start">
                <span
                  className="placeholder d-block col-6 mb-2"
                  style={{ height: 24, borderRadius: 4 }}
                  aria-hidden="true"
                />
                <span
                  className="placeholder d-block col-4"
                  style={{ height: 20, borderRadius: 4 }}
                  aria-hidden="true"
                />
              </div>
            </div>

            <hr className="my-4" />

            <div className="row align-items-center mt-5 mb-3">
              <div className="col-12 col-md-3 col-xxl-2 mb-3 text-md-center">
                <label className="col-form-label font-15">Full Name</label>
              </div>
              <div className="col-12 col-md-8 mb-4">
                <span
                  className="placeholder d-block w-100"
                  style={{ height: 38, borderRadius: 5 }}
                  aria-hidden="true"
                />
              </div>
            </div>

            <div className="row align-items-center mb-4">
              <div className="col-12 col-md-3 col-xxl-2 mb-3 text-md-center">
                <label className="col-form-label font-15">Grade</label>
              </div>
              <div className="col-12 col-md-8 mb-4">
                <span
                  className="placeholder d-block w-100"
                  style={{ height: 38, borderRadius: 5 }}
                  aria-hidden="true"
                />
              </div>
            </div>

            <div className="row align-items-center mb-5">
              <div className="col-12 col-md-3 col-xxl-2 mb-4 text-md-center">
                <label className="col-form-label font-15">Profile Photo</label>
              </div>

              <div className="col-12 col-md-8 pl-0">
                <div className="row">
                  <div className="col-md-4 col-lg-3 text-center text-md-start">
                    <span
                      className="placeholder d-block wh-150px rounded-circle mx-auto mx-md-0"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="col-md-8 col-lg-9 py-4 px-md-4 text-center text-md-start">
                    <span
                      className="placeholder d-block col-4 mb-2 mt-3"
                      style={{ height: 40, borderRadius: 5 }}
                      aria-hidden="true"
                    />
                    <span
                      className="placeholder d-block col-8"
                      style={{ height: 16, borderRadius: 4 }}
                      aria-hidden="true"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="d-grid gap-2">
               <span
                  className="placeholder d-block w-100"
                  style={{ height: 45, borderRadius: 5 }}
                  aria-hidden="true"
                />
            </div>
          </div>
        </div>
      </div>
      <img className="bg-bottom" src={bgBottom} alt="img" />
      <div style={{ height: 150 }}></div>
      <span className="visually-hidden">Loading…</span>
    </div>
  );
};

export default memo(EditProfileSkeleton);
